import { Container, Richtext } from '@volkswagen-onehub/components-core';
import React from 'react';
import { DisclaimerTextLegal } from '../../../shared/ui/disclaimer-text-legal';

interface DisclaimerContentProps {
	text: string;
	isPDF?: boolean;
}

export const HuchaDisclaimer2Content = ({ text, isPDF = false }: DisclaimerContentProps): React.JSX.Element => {
	return (
		<Container wrap={'always'}>
			<DisclaimerTextLegal isPDF={isPDF}>
				{'2. '}
				<Richtext dangerouslyParseRawHTML markdown={text} />
			</DisclaimerTextLegal>
		</Container>
	);
};
